// Wrapper around the WASM crypto core (M0). All vault cryptography runs here, in the
// browser (§4) — the backend never sees plaintext or keys. Functions mirror the Rust
// `wasm` bindings; the higher-level unlock/decrypt flow lands in M2.1.
import init, * as wasm from "../cryptocore/vault_crypto_core.js";

let ready: Promise<void> | null = null;

/** Initialize the WASM module exactly once. Safe to call repeatedly. The optional
 *  `moduleOrPath` lets non-web hosts (browser-extension service worker) point at the
 *  bundled .wasm explicitly instead of relying on import.meta.url resolution. */
export function initCrypto(moduleOrPath?: string | URL): Promise<void> {
  if (!ready) {
    ready = init(moduleOrPath !== undefined ? { module_or_path: moduleOrPath } : undefined).then(() => undefined);
  }
  return ready;
}

export { wasm };
